import React from 'react'
import Box from '../../UI'
import { Button, Typography, IconButton, Tooltip } from '@material-ui/core'
import { Link } from 'react-router-dom';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import InfoIcon from '@material-ui/icons/Info';
import AllInboxIcon from '@material-ui/icons/AllInbox';

export default function Process({ propertyId }) {
    return (
        <Box display='flex' justifyContent='space-between'>
            <Box width='50%' display='flex' alignItems='center'>
                <Typography variant='h6'><strong>Net Process Cost: £14,500</strong></Typography>
                <Tooltip title="Auction cost: Net of LoI charge pot" aria-label="view">
                    <IconButton color="inherit" aria-label="menu">
                        <InfoIcon style={{ fontSize: '16px' }} color="primary" />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box width='50%' display='flex' justifyContent='flex-end'>
                <Button 
                    variant='contained' 
                    style={{marginRight: '1rem'}} 
                    component={Link} 
                    to={`/my-portfolio/${propertyId}/loi-report`} 
                    startIcon={<AllInboxIcon />}
                >
                    LoI report
                </Button>
                <Button variant='contained' color='primary'	startIcon={<PlayCircleFilledIcon />}>Blast Now</Button>
            </Box>
        </Box>
    )
}
